import * as Yup from "yup"
import { TRANSLATION_INDEX_GLOBAL } from "../../config/translation"

export default Yup.object().shape({
  usuario: Yup.string()
    .required(TRANSLATION_INDEX_GLOBAL.REQUIRED)
    .matches(/[a-zA-ZÀ-ÿ\u00f1\u00d1']+$/, "No se puede ingresar numeros y y caracteres especiales")
})
